<template>
    <figure
        v-if="image"
        class="image-single"
    >
        <ImageAsset
            :image="image"
            :image-alt="alt"
        />
        <figcaption
            v-if="caption"
            class="image-single__caption"
        >
            {{ caption }}
        </figcaption>
    </figure>
</template>

<script setup>
defineProps({
    caption: {
        type: String,
        required: false,
        default: ''
    },
    alt: {
        type: String,
        default: ''
    },
    image: {
        type: Object,
        required: true
    }
});
</script>

<style lang="less" src="./ImageSingle.less" />
